<template>
    <div class="register-form">
        <div class="box">
            <div>
                <p class="first-text">
                    Bine ai venit pe <span style="font-weight: 900"> Smis</span>®
                </p>
                <p class="second-text">Înregistrare cont nou</p>
            </div>
            <div>
                <validation-observer #default="{ invalid }">
                    <b-form @submit.prevent="registerMethod">
                        <b-form-group
                            id="name-group"
                            label="Nume Complet"
                            label-for="name"
                            class="w-100"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="name"
                            >
                                <b-form-input
                                    id="name"
                                    v-model="register.name" type="text"
                                    placeholder="Nume prenume"
                                    :state="errors.length > 0 ? false : null"
                                    class="w-100"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('name')"
                                class="error-message"
                                v-text="errors.get('name')"
                            ></span>
                        </b-form-group>
                        <b-form-group
                            id="phone-group"
                            label="Telefon"
                            label-for="phone"
                            class="w-100"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="phone"
                            >
                                <b-form-input
                                    id="phone"
                                    v-model="register.phone"
                                    type="tel"
                                    placeholder="0722222222"
                                    :state="errors.length > 0 ? false : null"
                                    class="w-100"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('phone')"
                                class="error-message"
                                v-text="errors.get('phone')"
                            ></span>
                        </b-form-group>
                        <b-form-group
                            id="email-group"
                            label="Email"
                            label-for="email"
                            class="w-100"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required|email"
                                name="email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="register.email"
                                    type="email"
                                    placeholder="john@email.com"
                                    :state="errors.length > 0 ? false : null"
                                    class="w-100"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('email')"
                                class="error-message"
                                v-text="errors.get('email')"
                            ></span>
                        </b-form-group>
                        <b-form-group
                            id="password-group"
                            label="Parolă"
                            label-for="password"
                            class="w-100 position-relative"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="password"
                            >
                                <b-form-input
                                    id="password"
                                    v-model="register.password"
                                    :type="passwordFieldType"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="*******"
                                    class="w-100"
                                ></b-form-input>
                                <span
                                    toggle="#password-field"
                                    class="fa fa-fw fa-eye field-icon toggle-password"
                                    @click="switchVisibility"
                                ></span>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('password')"
                                class="error-message"
                                v-text="errors.get('password')"
                            ></span>
                        </b-form-group>
                        <b-form-group
                            id="confirm-password-group"
                            label="Confirma Parolă"
                            label-for="confirm-password"
                            class="w-100"
                        >
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                name="password"
                            >
                                <b-form-input
                                    id="confirm-password"
                                    v-model="register.password_confirmation"
                                    type="password"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="*********"
                                    class="w-100"
                                ></b-form-input>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('confirm-password')"
                                class="error-message"
                                v-text="errors.get('confirm-password')"
                            ></span>
                        </b-form-group>
                        <b-form-group>
                            <validation-provider
                                #default="{ errors }"
                                name="Termeni și condiții"
                                :rules="{ required: { allowFalse: false } }"
                            >
                                <b-form-checkbox
                                    id="register-privacy-policy"
                                    v-model="register.status"
                                    name="checkbox-1"
                                >
									Sunt de acord cu <a href="https://smis.ro/termeni-si-conditii/" target="_blank">termenii și condițiile</a>, <a href="https://smis.ro/politica-de-confidentialitate/" target="_blank">politica de confidentialitate</a>, <a href="https://smis.ro/cookies-gdpr" target="_blank">politica de cookies</a>, <a href="https://smis.ro/politica-livrare-servicii" target="_blank">politica de livrare</a> și <a href="https://smis.ro/politica-retur" target="_blank">politica de retur</a>.
								</b-form-checkbox>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            <span
                                v-if="errors.has('Termeni și condiții')"
                                class="error-message"
                                v-text="errors.get('Termeni și condiții')"
                            ></span>
                        </b-form-group>
                        <div>
                            <b-button
                                type="submit"
                                variant="primary"
                                block
                                :disabled="invalid"
                            >Înregistrare cont
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
                <div class="logare logare-wrapper">
                    <p class="logare">
                        Ai deja un cont?
                        <router-link class="text-blue" :to="'/login'+utmParam"> Logare </router-link>
                    </p>
                </div>
            </div>
        </div>
        <TermeniPopup
            :schimbaModal="modalShow"
            @termsAccepted="register.status = true; modalShow = false"
            @hideTempModal="modalShow = false"
        ></TermeniPopup>
    </div>
</template>

<script>
    import {BForm, BFormGroup, BFormInput, BButton, BSpinner, BFormCheckbox, BLink} from 'bootstrap-vue';
    import ButtonGradient from "../../../common/components/ButtonGradient";
    import TermeniPopup from "./TermeniPopup";
    import api from '@/helpers/api'
    import {startSession} from '@/helpers/auth'
    import axios from '@/helpers/axios'
    import Errors from '@/helpers/Errors';
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')



    export default {
        components: {
            ButtonGradient,
            BForm,
            BFormGroup,
            BFormInput,
            BButton,
            BSpinner,
            ValidationProvider,
            ValidationObserver,
            BFormCheckbox,
            TermeniPopup,
            BLink
        },
        props: {},
        data() {
            return {
                confirmMessage: 'Adresa de email trebuie verificată! Te rugăm să o verifici accesând email-ul în secțiunea inbox sau spam.',
                register: {
                    name: '',
                    email: '',
                    phone: '',
                    password: '',
                    password_confirmation: '',
                    utm_source: this.$route.query.utm_source ? this.$route.query.utm_source : null,
                    location: 'm3',
                    status: false,
                },
                errors: new Errors(),
                passwordFieldType: "password",
                utmParam: null,
                modalShow: false
            };
        },
        created() {
            this.utmParam = this.$route.query && this.$route.query.utm_source ? '?utm_source=' + this.$route.query.utm_source : '';
        },
        methods: {
            openTerms() {
                this.modalShow = !this.modalShow;
            },
            switchVisibility() {
                this.passwordFieldType =
                    this.passwordFieldType === "password" ? "text" : "password";
            },
            registerMethod() {
                this.$emit('registerStarted')
                startSession().then(() => {
                    let config = {
                        headers: {
                            'form-origin': 'm3'
                        }
                    }
                    axios
                        .post(api.API_ENDPOINTS.register, this.register, config)
                        .then(() => {
                            this.$emit('registerEnded')
                            this.$store.dispatch('auth/logoutForVerification');
                            this.$toast.success('Te-ai înregistrat cu succces!');
                            this.$router.push({
                                params: { confirmMessage: this.confirmMessage },
                                path: api.LOGIN_ROUTE,
                                name:'Login'
                            })
                        })
                        .catch(xhr => {
                            this.$emit('registerEnded')
                            if (xhr && xhr.response && xhr.response.status === 422) {
                                this.errors.record(xhr.response.message);
                            }
                            this.$toast.error(xhr.response.data.message,{ duration:1000 });
                        })
                });
            },
        },
    };
</script>

<style scoped>
    .box {
        display: flex;
        flex-direction: column;
        padding: 0 40px;
    }
    form {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    label {
        margin-bottom: 2px;
        font-size: 14px;
        color: #818181;
    }
    input:not([type="checkbox"]) {
        margin-bottom: 10px;
        width: initial;
        line-height: 30px;
        border-radius: 5px;
        border: 1px solid #e7e1e7;
        padding-left: 10px;
        color: #818181;
    }

    input:focus {
        outline: none !important;
        border: 1px solid #6793ce;
    }

    input::placeholder {
        color: #cac5d4;
    }

    .first-text {
        font-size: 22px;
        font-weight: 600;
        background: -webkit-linear-gradient(#262728, #4e5359);
        background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: left;
    }

    .second-text {
        font-size: 18px;
        margin: 30px 0 20px 0;
        color: #818181;
        text-align: left;
    }

    .form-field {
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
    }

    .checkbox-field {
        display: flex;
        flex-direction: row;
        margin-right: auto;
        align-items: center;
    }

    .field-icon {
        position: absolute;
        z-index: 2;
        cursor: pointer;
        right: 15px;
        bottom: 18px;
    }

    .buton-register {
        margin-top: 35px;
    }

    .logo-mic {
        position: absolute;
        bottom: 40px;
        right: 50px;
    }

    .logare {
        text-align: center;
        margin-top: 20px;
    }

    .text-blue {
        color: #4d87f1;
    }
    @media (max-height: 800px) {
        .second-text{
            margin-bottom: 20px;
            margin-top: 0;
        }
        .form-group{
            margin-bottom: 0.5rem;
        }
        .form-group >>> label{
            margin-bottom: 0.2rem;
            font-size: 13px;
        }
        .form-group >>> .custom-checkbox label{
            font-size: 13px;
        }
        .btn-primary{
            font-size: 13px;
            margin-top: 10px;
        }
    }
    @media (max-width: 1281px) {
        .first-text {
            font-size: 19px;
        }
        .second-text {
            margin: 10px 0px;
        }
    }
    @media (max-width: 1368px) {
        .date-user .register-form .form-group {
            margin-bottom: 5px;
        }
        .date-user .register-form .form-group >>> label {
            font-size: 12px;
        }
        .second-text {
            font-size: 14px;
            margin: 10px 0px;
        }
        .first-text {
            font-size: 15px;
        }
        .logare {
            margin-top: 5px;
        }
        .custom-control >>> label{
            font-size: 10px!important;
        }
    }
    @media (max-width: 820px) {
        .second-text, form, .logare {
            font-size: 14px;
            margin: 0;
        }

        .second-text {
            margin-bottom: 5px;
        }

        .form-group {
            margin: 0;
        }

        .form-control {
            height: 33px;
        }
        .logo-mic img {
            max-width: 18px;
        }
        .buton-register {
            margin-top: 15px;
        }
        .logare-wrapper {
            margin-top: 10px;
        }
    }
    .custom-control-label a{
        color: #7eabed;
    }
    @media (max-width: 840px) {
        .second-text, form, .logare {
            color: #fff;
        }
        .first-text {
            background: -webkit-linear-gradient(#ffffff, #efefef);
            -webkit-background-clip: text;
        }
    }
    @media (max-width: 330px) {
        .second-text, form, .logare {
            font-size: 12px;
        }

        .first-text {
            font-size: 15px;
        }

        .form-control {
            height: 28px;
        }

        label {
            margin: 0 !important;
        }
    }
</style>

<style>
    @media (max-width: 330px) {
        .date-user label {
            margin: 0;
        }
    }
     .register-form .custom-control-input:checked ~ .custom-control-label::before{
        color: #fff;
        border-color: #007bff !important;
        background-color: #007bff !important;
    }

</style>
